import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { Button } from './ui/button'

interface CloseConfirmationModalProps {
  open: boolean
  setOpen: (state: boolean) => void
  onConfirm: () => void // Function to handle closing without saving
  title?: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
}

export default function CloseConfirmationModal({
  open,
  setOpen,
  onConfirm,
  title = 'Unsaved Changes',
  description = 'Are you sure you want to close this form? Any unsaved changes will be lost.',
  confirmLabel = 'Close without saving',
  cancelLabel = 'Cancel',
}: CloseConfirmationModalProps) {
  //   const [_open, _setOpen] = useState(open)

  //   useEffect(() => {
  //     _setOpen(open)
  //   }, [open])

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogClose>
            <XMarkIcon />
          </DialogClose>
        </DialogHeader>

        <DialogBody>
          <p>{description}</p>
        </DialogBody>

        <DialogFooter>
          <Button type="button" variant="destructive" onClick={onConfirm}>
            {confirmLabel}
          </Button>

          <DialogClose asChild>
            <Button type="button" variant="secondary">
              {cancelLabel}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
